/* eslint-disable class-methods-use-this */
import { Requests } from '@nx-smartmonkey/shared/helpers';
import { ApiKey } from '../../domain/apiKey/ApiKey';
import { ApiKeyMapper } from '../../mappers/apiKey/ApiKeyMapper';
import { SessionRepository } from '../session/SessionRepository';
import { ApiKeyRepository } from './ApiKeyRepository';

export class ApiKeyRepositoryApi implements ApiKeyRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}
  async create({ label }: { label?: string }): Promise<ApiKey> {
    const response = await this.requests.post({
      uri: `/api-key`,
      data: {
        label,
      },
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return ApiKeyMapper.toDomain(response.data);
  }

  async fetchAll(): Promise<ApiKey[]> {
    const response = await this.requests.get({
      uri: `/api-keys`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return response.data.map((apiKey: any) => ApiKeyMapper.toDomain(apiKey));
  }

  async update({ apiKey }: { apiKey: ApiKey }): Promise<ApiKey> {
    const apiKeyDTO = ApiKeyMapper.toRepository(apiKey);

    const response = await this.requests.put({
      uri: `/api-key/${apiKey.id}`,
      data: {
        label: apiKeyDTO.label,
        active: apiKeyDTO.active,
      },
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return ApiKeyMapper.toDomain(response.data);
  }

  async delete({ apiKey }: { apiKey: ApiKey }): Promise<ApiKey> {
    await this.requests.delete({
      uri: `/api-key/${apiKey.id}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return apiKey;
  }

  // !!! When the use cases are needed and implemented in the api, uncomment these methods

  // async fetchById({ apiKey_id }: { apiKey_id: string }): Promise<ApiKey> {
  //   const response = await this.requests.get({
  //     uri: `/api-key/${apiKey_id}`,
  //     headers: this.sessionRepository.getAuthenticationHeader(),
  //   });
  //   return ApiKeyMapper.toDomain(response.data);
  // }

  // async fetchByKey({ apiKey_key }: { apiKey_key: string }): Promise<ApiKey> {
  //   const response = await this.requests.get({
  //     uri: `/api-key/${apiKey_key}`,
  //     headers: this.sessionRepository.getAuthenticationHeader(),
  //   });
  //   return ApiKeyMapper.toDomain(response.data);
  // }

  // !!!
}
